import { Fragment } from 'react';
import { Text } from '~/components/ui/Text';
import { VehicleNumberPlate, VehicleNumberPlateType } from '~/shared';
import { NumberPlatePreviewSize } from './NumberPlatePreview.model';
import {
	StyledContainer,
	StyledCustomNumberContainer,
	StyledDivider,
	StyledNumberContainer,
	StyledPlateLetter,
	StyledPlateNumber,
	StyledRegionContainer,
} from './NumberplatePreview.styled';

const NumberplatePreview = ({
	numberPlate,
	size,
	dark,
}: {
	numberPlate: VehicleNumberPlate | null | undefined;
	size: NumberPlatePreviewSize;
	dark?: boolean;
}) => {
	if (!numberPlate) {
		return;
	}

	if (
		size === NumberPlatePreviewSize.Size20 &&
		(numberPlate?.type === VehicleNumberPlateType.Classic ||
			numberPlate?.type === VehicleNumberPlateType.ClassicNoFlag ||
			// numberPlate?.type === VehicleNumberPlateType.ClassicSquare ||
			numberPlate?.type === VehicleNumberPlateType.ClassicSquareNoFlag)
	) {
		return (
			<StyledContainer $dark={dark} $size={size}>
				<Text style={{ fontWeight: 700, height: 21 }}>
					<span style={{ fontSize: 10 }}>{numberPlate?.text.slice(0, 1)}</span>
					<span style={{ fontSize: 6 }}>&nbsp;</span>
					<span style={{ fontSize: 12 }}>{numberPlate?.text.slice(1, 4)}</span>
					<span style={{ fontSize: 8 }}>&nbsp;</span>
					<span style={{ fontSize: 10 }}>{numberPlate?.text.slice(4, 6)}</span>
				</Text>
				<StyledDivider $dark={dark} />
				<Text
					style={{
						fontWeight: 700,
						fontSize: 10,
						lineHeight: 10,
					}}
				>
					{numberPlate?.region}
				</Text>
			</StyledContainer>
		);
	}

	if (
		size === NumberPlatePreviewSize.Size20 &&
		(numberPlate?.type === VehicleNumberPlateType.Custom ||
			numberPlate?.type === VehicleNumberPlateType.CustomBlack)
	) {
		return (
			<StyledContainer $dark={dark} $size={size}>
				<Text
					style={{
						fontWeight: 700,
						fontSize: 10,
						width: '100%',
						textAlign: 'center',
					}}
				>
					{numberPlate?.text}
				</Text>
			</StyledContainer>
		);
	}

	return (
		<StyledContainer $dark={dark} $size={size}>
			{(numberPlate?.type === VehicleNumberPlateType.Classic ||
				numberPlate?.type === VehicleNumberPlateType.ClassicNoFlag ||
				// numberPlate?.type === VehicleNumberPlateType.ClassicSquare ||
				numberPlate?.type === VehicleNumberPlateType.ClassicSquareNoFlag) && (
				<Fragment>
					<StyledNumberContainer $dark={dark}>
						<Text>
							{numberPlate?.text.split('').map((char, index) => {
								const numeric = /^[0-9]+$/.test(char);
								return numeric ? (
									<StyledPlateNumber key={`n#${index}`}>
										{char}
									</StyledPlateNumber>
								) : (
									<StyledPlateLetter key={`l#${index}`}>
										{char}
									</StyledPlateLetter>
								);
							})}
						</Text>
					</StyledNumberContainer>
					<StyledRegionContainer>
						<span>{numberPlate?.region ?? ''}</span>
						<span>RUS</span>
					</StyledRegionContainer>
				</Fragment>
			)}
			{(numberPlate?.type === VehicleNumberPlateType.Custom ||
				numberPlate?.type === VehicleNumberPlateType.CustomBlack) && (
				<StyledCustomNumberContainer>
					<StyledPlateLetter>{numberPlate?.text}</StyledPlateLetter>
				</StyledCustomNumberContainer>
			)}
		</StyledContainer>
	);
};
export { NumberplatePreview };
